import {
  Breakpoints,
  FAIcon,
  IconStyle,
  useBreakpoint,
  useFeatureVisibility,
  useTranslation,
} from '@nextgen-web-framework/all';
import styles from './shopfinder.module.scss';
import ShopOptionRadioCard from './ShopOptionRadioCard';
import { IShopsOptions, ShopLayoutProps } from './types/propsTypes';

const ShopListLayout = ({
  setSelectedShop,
  availableShops,
  shopLocations,
  selectedShop,
  shopDetails,
  isLocationAccessAllowed,
  setShowFullScreenMap,
}: ShopLayoutProps) => {
  const translate = useTranslation();
  const config = ConfigService.getConfigs();
  const viewPortType = useBreakpoint() as Breakpoints;
  const isMobileView = viewPortType == Breakpoints.XS || viewPortType == Breakpoints.SM;
  const ASSETS_BASE_PATH = config.NEXT_ASSETS_BASE_PATH;
  const isFullScreenMapCtaVisible = useFeatureVisibility?.('webshop.enableMobileMapFullscreenView');
  const shopListHeading = (
    <div className={styles['shop-list-heading']}>
      {translate(isLocationAccessAllowed ? 'web.shopFinder.shopsNearYou' : 'web.shopFinder.availableShops')}{' '}
      {`(${availableShops})`}
    </div>
  );
  return (
    <>
      {isMobileView && isFullScreenMapCtaVisible ? (
        <div className={styles['shop-list-container']}>
          {shopListHeading}
          <div
            role="button"
            className={styles['view-google-map']}
            aria-label={'Show Full Screen Map'}
            tabIndex={0}
            onClick={() => {
              if (setShowFullScreenMap) {
                setShowFullScreenMap(true);
              }
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                if (setShowFullScreenMap) {
                  setShowFullScreenMap(true);
                }
              }
            }}
          >
            <FAIcon iconName="location-dot" iconStyle={IconStyle.REGULAR} data-testid="close-icon-testid" />
            <span className={styles['view-google-map-text']}>{translate('web.shopFinder.viewMap')}</span>{' '}
          </div>
        </div>
      ) : (
        <>{shopListHeading}</>
      )}
      <div className={styles['shop-list']} id="scrollableShopListContainer">
        {shopLocations?.map((shop: IShopsOptions) => (
          <div key={shop.id} id={shop.id}>
            <ShopOptionRadioCard
              cardData={shop}
              isSelected={selectedShop === shop?.id}
              setSelectedShop={setSelectedShop}
              shopDetails={(data) => shopDetails(data)}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default ShopListLayout;
